//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from 'qs'
import Window from '../utils/Window'
// 是否是H5渠道
let h5 = false
let timer = null
export default {
  name: 'm-pay',
  data () {
    return {
      bankList: [],
      banksFromServerData: [],
      agreeTerms: true,
      ticketDialog: false,
      productBackMoney: 0,
      couponsName: '',
      actualPrice: 0,
      thisPrice: 0,
      backMoney: 0,
      h5: h5,
      Window: Window,
      productCode: location.host === 'test.m.wkbins.com' ? '149673981474815463' : '149674766585200396',
      currentProductIndexURL: '',
      commonResultURL: ''
    }
  },
  created () {
    this.$http.get('/api/bank/quota/getListByProductsCode?productCode=' + this.productCode).then(response => {
      let banksFromServer = response.data
      this.banksFromServerData = banksFromServer.data
      // alert(banksFromServer.data)
      // alert(banksFromServer.result, banksFromServer.data.length)
      // console.log(banksFromServer.data)
      // console.log(typeof banksFromServer.result, banksFromServer.data.length)
      if ((banksFromServer.result === 'true' || banksFromServer.result === true) && banksFromServer.data.length > 0) {
        banksFromServer.data.forEach((ele) => {
          this.bankList.push({name: ele.bankName, value: ele.bankCode})
        })
      }
    })
  },
  mounted () {
    this.$store.commit('updateProductId', this.$route.params.productId)
    this.$store.commit('updateUserId', this.$route.params.userId)
    // this.$store.commit('updateOrderOpenId', this.$route.params.openId)
    this.$store.commit('updateOrderUnionOrderCode', this.$route.params.unionCode)

    this.currentProductIndexURL = window.location.pathname + '#/' + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '?' + qs.stringify(this.$route.query)
    this.commonResultURL = '/products/' + this.$store.state.order.productId + '/result?' + (this.h5 ? 'merchantCode' : 'innerCode') + '=' + this.$store.state.order.userId + '&unionCode=' + this.$store.state.order.unionOrderCode + '&indexURL=' + encodeURIComponent(this.currentProductIndexURL)

    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true
    }
    const data = {}
    if (this.$route.query.activityCode) {
      data.activityCode = this.$route.query.activityCode
    }
    this.$http.get((this.h5 ? '/api/channel/hqdqx/orderQueren/' : '/api/hqdqx/orderQueren/') + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/' + this.$store.state.order.unionOrderCode + '?' + qs.stringify(data)).then(response => {
      this.$store.commit('updateOrderName', response.data.busProductRelation.productName)
      this.$store.commit('updateOrderCompany', response.data.busProductRelation.suppliername)
      this.$store.commit('updateOrderNumber', response.data.busOrder.orderCode)
      this.$store.commit('updateInsuredName', response.data.underwritingInfoList[0].policyInsured.insuredName)
      this.$store.commit('updateInsuredIDNumber', response.data.underwritingInfoList[0].policyInsured.insuredIdNumber)
      this.$store.commit('updateOrderInsuranceAmount', response.data.underwritingInfoList[0].coverageMultiples / 100 + '')
      this.$store.commit('updateOrderPaymentPeriod', response.data.underwritingInfoList[0].insurePayWay + '')
      this.$store.commit('updateOrderInsurancePeriod', response.data.underwritingInfoList[0].durationPeriodValue + '')
      this.$store.commit('updateHolderPhoneNumber', response.data.underwritingInfoList[0].policyHolder.holderPhone)
      // this.$store.commit('updatePaymentByIDNumber', response.data.underwritingInfoList[0].premium / response.data.underwritingInfoList[0].coverageMultiples)
      this.thisPrice = response.data.underwritingInfoList[0].premium / 100
      this.actualPrice = response.data.actualPrice / 100
      this.productBackMoney = response.data.productBackMoney
      this.backMoney = response.data.backMoney
      this.couponsName = response.data.couponsName
      const passSeconds = Math.floor((Date.now() - response.data.orderCreateDate) / 1000)
      const countdownTimer = 1800 - passSeconds
      this.$store.commit('updateOrderCountdownTimer', countdownTimer < 0 ? 0 : countdownTimer)
      timer = setInterval(() => {
        if (this.$store.state.order.countdownTimer <= 0) {
          clearInterval(timer)
        }
        this.$store.commit('updateOrderCountdownTimer', this.$store.state.order.countdownTimer - 1)
      }, 1000)
    })
    document.title = '支付详情'
  },
  destroyed () {
    clearInterval(timer)
  },
  computed: {
    orderNumber () {
      return this.$store.state.order.number
    },
    orderName () {
      return this.$store.state.order.name
    },
    paymentByIDNumber () {
      return this.$store.getters.computPaymentByIDNumber
    },
    insuredName () {
      return this.$store.state.insured.name
    },
    insuredIDNumber () {
      return this.$store.state.insured.IDNumber
    },
    holderPhoneNumber () {
      return this.$store.state.holder.phoneNumber
    },
    bankName: {
      get () {
        console.log(this.$store.state.holder.bankName)
        return this.$store.state.holder.bankName
      },
      set (value) {
        console.log(value)
        console.log(this.$store.state.holder.bankName)
        this.$store.commit('updateHolderBankName', value)
      }
    },
    bankCardNumber: {
      get () {
        return this.$store.state.holder.bankCardNumber
      },
      set (value) {
        this.$store.commit('updateHolderBankCardNumber', value)
      }
    }
  },
  methods: {
    payWithWX () {
      const price = this.actualPrice || this.thisPrice
      // const price = 50001 // 测试超出限额是否调用微信支付
      // console.log(price, this.banksFromServerData, this.bankName)
      // alert('判断微信支付是否成立')
      for (let i = 0; i < this.banksFromServerData.length; i++) {
        console.log(this.banksFromServerData[i].bankCode, this.bankName[0], price, this.banksFromServerData[i].bankSingleQuota / 100)
        if (this.banksFromServerData[i].bankCode === this.bankName[0] && price > (this.banksFromServerData[i].bankSingleQuota / 100)) {
          // alert(price, this.banksFromServerData, this.banksFromServerData[i].bankSingleQuota / 100, this.bankName[0])
          // alert('调用微信支付条件成立')
          return true
        }
      }
      return false
    },
    openNewWindow (url) {
      window.open(url)
    },
    submitPay () {
      if (this.bankName.length === 0) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请选择银行',
          position: 'top',
          width: '20em'
        })
        return
      }
      if (this.bankCardNumber.length === 0) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入银行卡号',
          position: 'top',
          width: '20em'
        })
        return
      }
      // 银行卡号必须在15-19位中间
      if (!(this.bankCardNumber.length > 14 && this.bankCardNumber.length < 20)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请正确输入银行卡号',
          position: 'top',
          width: '20em'
        })
        return
      }
      if (!this.agreeTerms) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请您认真阅读理解并同意支付授权声明后再试',
          position: 'top',
          width: '20em'
        })
        return
      }
      const data = {
        orderCode: this.$store.state.order.number,
        innerCode: this.$store.state.order.userId,
        bankCode: this.$store.state.holder.bankName[0],
        hengqinBankCode: this.$store.getters.bankCode,
        bankCardNum: this.$store.state.holder.bankCardNumber
      }
      if (this.$route.query.activityCode) {
        data.activityCode = this.$route.query.activityCode
      }
      if (this.$store.state.order.countdownTimer <= 0) {
        const that = this
        this.$vux.confirm.show({
          confirmText: '重新下单',
          title: '订单逾期',
          content: '订单逾期，请重新下单！',
          onConfirm () {
            that.$router.push({name: 'Form', params: {productId: that.$store.state.order.productId, userId: that.$store.state.order.userId}, query: that.$route.query})
          }
        })
        return
      }
      // TODO
      // 请求宝付
      // 6217001370007197429
      // 43062319950315721X
      // zhonganyuann
      // 吴亮
      // 320623199304044698
      // 13521320175
      // 尹成祥
      // 142303199508304910
      // 6217000010049570610
      this.$vux.loading.show({
        text: '正在支付'
      })
      if (this.payWithWX()) {
        // alert('金额符合条件进入下一步判断是否是微信环境')
        if (this.isWX()) {
          data.payWay = 1
          // alert('微信环境')
          // console.log(data)
        } else {
          data.payWay = 12
          // alert('非微信环境')
          // console.log(data)
        }
      }
      this.$http.post('/api/pay/baofooPayWithholdFresh/' + this.$store.state.order.unionOrderCode + '/' + this.$store.state.order.userId, qs.stringify(data)).then(response => {
        this.$vux.loading.hide()
        // alert('第一层校验的' + response.data + data.payWay)
        if (response.data === 302) { // 跳转到微信
          // 校验银行卡号
          this.$http.get('/api/pay/bankcard/check?' + 'bankCode=' + this.bankName[0] + '&bankCardNum=' + this.bankCardNumber + '&unionOrderCode=' + this.$store.state.order.unionOrderCode).then(response => { // this.$store.state.order.unionCode
            const _this = this
            let resultdata = response.data
            if (resultdata.code === 'false') {
              // _this.$vux.toast.show({
              //   type: 'text',
              //   text: resultdata.msg,
              //   position: 'top',
              //   width: '20em'
              // })
              _this.$vux.confirm.show({
                title: '提示',
                content: '<p style="text-align: left; line-height: 1.5rem; margin-top: .5rem;">' + resultdata.msg + '</p>',
                confirmText: '咨询客服',
                cancelText: '取消',
                onCancel () {
                },
                onConfirm () {
                  window.location.href = 'tel:400-661-2992'
                }
              })
            } else {
              // alert('最后判断条件成立，调用微信支付')
              window.location.href = '/common/wxpay?order=' + _this.$store.state.order.unionOrderCode + '&redirect_uri=' + encodeURIComponent(_this.commonResultURL) + '&pay_uri=' + encodeURIComponent(window.location.href)
            }
          })
          return false
        }
        if (response.data !== true) {
          this.$vux.confirm.show({
            title: '提示',
            content: '<p style="text-align: left; line-height: 1.5rem; margin-top: .5rem;">' + response.data.substring(6) + '</p>',
            confirmText: '咨询客服',
            cancelText: '取消',
            onCancel () {
            },
            onConfirm () {
              window.location.href = 'tel:400-661-2992'
            }
          })
          // this.$vux.toast.show({
          //   type: 'text',
          //   text: response.data.substring(6),
          //   position: 'top',
          //   width: '20em'
          // })
          return false
        }
        // alert('没有调用微信支付')
        window.location.href = this.commonResultURL;
      })
    },
    showTicketDialog () {
      this.ticketDialog = true
    },
    isWX () {
      return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Pay.vue